// @ts-nocheck
//自定义过滤器
import Vue from 'vue'
import moment from 'moment'


// Vue.component(NoticeCard.name, NoticeCard);//通知卡片

Vue.filter('money', function (val) {
    return val && val
        .toString()
        .replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
            return $1 + ",";
        });
});

Vue.filter('price', function (val) {
    return (val * 1.00).toFixed(2);
});

Vue.filter('formatdatetime', function (el) {
    //  return  moment(el).format("YYYY-MM-DD HH:mm") 

    if (el == null || el == "") {
        return "";
    }
    else {
        return moment(el).format("YYYY-MM-DD HH:mm")
    }

});

Vue.filter('formatdate', function (el) {

    if (el == null || el == "") {
        return "";
    }
    else {
        return moment(el).format("YYYY-MM-DD")
    }
});

 


